import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={`${process.env.PUBLIC_URL}/IMG_2415.ico`} alt="" />
        <h1>ORBIT</h1>
        <p>Organization for Research in Big Data and Intelligent Technologies</p>
      </header>
      <div className="panda">
        <h2>
          Empowering students to innovate and lead in machine learning and
          artificial intelligence through hands-on projects, research, and
          industry collaborations.
        </h2>
        <a href="https://forms.fillout.com/t/9RzS15fYhsus">Start a Chapter</a>
      </div>
      <div className="squirrel">
        <footer>
          <p>
            © [2024] Organization for Research in Big Data and Intelligent
            Technologies. All rights reserved.
          </p>
          <div className="footer-icons">
            <a
              href="mailto:orbit_machinelearning@aol.com"
              className="icon"
            >
              <i className="fas fa-envelope"></i>
            </a>
            <a
              href="https://www.linkedin.com/company/orbit-club/"
              className="icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a
              href="https://www.instagram.com/orbit_machinelearning"
              className="icon"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-instagram"></i>
            </a>
          </div>
        </footer>
      </div>
    </div>
  );
}

export default App;